"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const facebookPixel_1 = require("root/src/client/logic/analytics/pixel/facebookPixel");
const googleAnalytics_1 = require("root/src/client/logic/analytics/googleAnalytics");
const tiktokPixelTrackEvent_1 = __importDefault(require("../events/tiktokPixelTrackEvent"));
function analyticsSendItem(eventName, label, value) {
    if (value && value > 0)
        (0, facebookPixel_1.addTrack)('Purchase', { value, currency: 'USD' });
    (0, tiktokPixelTrackEvent_1.default)(eventName, label);
    (0, googleAnalytics_1.gaSendEvent)(value, eventName, label);
}
exports.default = analyticsSendItem;
